import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import AppLoader from 'components/AppLoader';

const LazyLoadComponent = Component => props => (
  <Suspense fallback={<AppLoader style={{ background: 'transparent' }} />}>
    <Component {...props} />
  </Suspense>
);

LazyLoadComponent.propTypes = {
  Component: PropTypes.node,
};

LazyLoadComponent.defaultProps = {
  Component: null,
};

export default LazyLoadComponent;
